import React, { useEffect } from "react";
import {
    ClearableCheckboxDropdown,
    Table,
    TimestampFilters,
} from "dyl-components";
import { Table as SemanticTable } from "semantic-ui-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import SelectAllCheckbox from "shared/SelectAllCheckbox";
import { getData, onToggleTimeUnit, useRangeCalendar } from "shared/CustomDateRange/customDateRange";
import SortActions from "pages/Groups/subcomponents/SortActions";
import { useDispatch, useSelector } from "react-redux";
import archiveAction from "actions/archive"
import "./index.scss";

const ArchivedReportsHeader = ({ onFilter, count = 0 }) => {
    const [params] = useSearchParams();

    const {
        timestamp,
        setTimestamp,
        isCustomDateRangeOpen,
        setCustomDateRangeOpen,
        userAuthTimezone,
        dateRange,
        setDateRange,
    } = useRangeCalendar(params);

    const createdOrder =
        (params.get("order_by") === "archived_date") &&
        params.get("order") === "asc";

    const onDateRangeChange = (_, { value }) => {
        setDateRange(value);
    };
    const navigate = useNavigate()

    const createdOrderFilter = () => {
        const order = params.get("order") !== "asc" ? "asc" : "desc";
        const query = new URLSearchParams(params);
        query.set("order", order);
        query.set("order_by", "archived_date");
        const query_string = query.toString();
        navigate(
            `/settings/archived-records${query_string ? `?${query_string}` : ""}`
        );
    };

    const dispatch = useDispatch()
    const { archiveUsers } = useSelector((state) => state.archive)
    useEffect(() => {
        dispatch(archiveAction.getArchiveUsers())
    }, [dispatch])

    const archivedByOptions = archiveUsers.map(archivedBy => ({
        key: archivedBy?.id,
        value: archivedBy?.id.toString(),
        text: archivedBy?.username,
    })).sort((a, b) => a.text.localeCompare(b.text))
    return (
        <Table.Row>
            <SemanticTable.HeaderCell width={1}>
                <SelectAllCheckbox
                    count={count}
                    type={"DYL numbers"}
                    data={[]}
                    idProperty={"number"}
                    isDisabled
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell
                className="ContactsTable__MediumFixedWidth"
                width={3}
            >
                <span className="ArchivedReportsHeader__Date">Archived Date</span>
                <TimestampFilters
                    timestamp={timestamp}
                    onToggleTimeUnit={(timestamp) =>
                        onToggleTimeUnit(
                            timestamp,
                            setTimestamp,
                            params,
                            navigate,
                            `/settings/archived-records`,
                        )
                    }
                    isCustomDateRangeOpen={isCustomDateRangeOpen}
                    onOpenCustomDateRange={() => {
                        setCustomDateRangeOpen(true);
                    }}
                    onCloseCustomDateRange={() => {
                        setCustomDateRangeOpen(false);
                    }}
                    dateRange={dateRange}
                    onDateRangeChange={onDateRangeChange}
                    getData={() =>
                        getData({
                            setCustomDateRangeOpen,
                            dateRange,
                            userAuthTimezone,
                            params,
                            navigate,
                            url: `/settings/archived-records`,
                        })
                    }
                />

                <SortActions
                    direction={createdOrder}
                    onToggleSort={() => {
                        createdOrderFilter();
                    }}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={5}>
                Account/Contact
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={5}>
                <ClearableCheckboxDropdown
                    text="Archived By"
                    name="archived_by_user_id"
                    options={archivedByOptions}
                    onChange={(_, { name, value }) => {
                        onFilter(_, { name, value });
                    }}
                    value={params.get("archived_by_user_id")?.split(",")}
                    closeOnLoad={true}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={2}>
                Actions
            </SemanticTable.HeaderCell>
        </Table.Row>
    );
};

export default ArchivedReportsHeader;
